import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "ab-name-first-project-callout",
  templateUrl: "./name-first-project-callout.component.html",
})
export class NameFirstProjectCalloutComponent {
  @Input() public project: any;
  @Output() public dismissAndFollowLink = new EventEmitter<void>();

  public dismissAndFollow(event: any) {
    this.dismissAndFollowLink.emit(event);
  }
}
